import styled from "styled-components";
export const SelectWrapper = styled.div`
  width: 25%;
  @media (max-width: 991px) {
    width: 100%;
  }
`;
